// extracted by mini-css-extract-plugin
export var cardDescriptionCustom = "MagazinePreviewBlock-module--cardDescriptionCustom--cdbbf";
export var cardImageContainerCustom = "MagazinePreviewBlock-module--cardImageContainerCustom--506e2";
export var cardTextCustom = "MagazinePreviewBlock-module--cardTextCustom--b3d96";
export var magazineCardCustom = "MagazinePreviewBlock-module--magazineCardCustom--7de91";
export var magazineImageContainerCustom = "MagazinePreviewBlock-module--magazineImageContainerCustom--83b55";
export var previewLinkCustom = "MagazinePreviewBlock-module--previewLinkCustom--d3248";